
export const SET_LANGUAGE = "SET_LANGUAGE" ;
export const SET_GALLERY = "SET_GALLERY";
export const SET_USER = 'SET_USER';
export const SET_MESSAGES = 'SET_MESSAGES';

export const createAction = (action) => (dispatch) => dispatch(action);




